import { Checkbox } from "@mui/joy";
import { FieldValues, RegisterOptions, useController, useFormContext } from "react-hook-form";

type Props = {
  name: string;
  label: string;
  registerOptions?: RegisterOptions<FieldValues, string>;
  disabled?: boolean;
};

export default function CheckboxInput({ name, label, disabled }: Props) {
  const { control } = useFormContext();
  const { field } = useController({
    name,
    control,
    disabled,
  });
  return <Checkbox {...field} checked={!!field.value} label={label} disabled={disabled} />;
}
